import React, { Component } from 'react';
import { Media } from 'react-bootstrap';
import { Avatar } from '../../ui';
import { mixinsClassName, substrByBytes, genNickName, urls } from '../../utils';

export default class extends Component {
    render() {
        const { data, onClick, onDoubleClick } = this.props;
        let className = mixinsClassName(
            data.is_active ? "active" : "",
            this.props,
            "media-odd"
        );
        let name = data.name || genNickName(data.users);
        let avatar = data.avatar || urls.imageRoot + 'group.png';

        return (
            <Media className={className} 
                   onClick={onClick&&onClick.bind(this, data, "group")} 
                   onDoubleClick={onDoubleClick&&onDoubleClick.bind(this, data, "group")}
                   title="【双击】可进入会话">
              <Media.Left>
                <Avatar src={avatar} />
              </Media.Left>
              <Media.Body>
                <Media.Heading>{substrByBytes(name, 22)}</Media.Heading>
              </Media.Body>
            </Media>
        );
    }
}


// WEBPACK FOOTER //
// ./src/group/item/index.js